import React from 'react'
import useForgotPassword from 'pages/ForgotPassword/useForgotPassword'
import { Form, Formik } from 'formik'
import { forgetPasswordSchema } from 'pages/ForgotPassword/schema'
import Loader from 'components/Loader'
import FormFieldControl from 'components/FormFieldControl'
import { UserRegisterButton } from 'components/Buttons'
import { AUTH_MODAL_TABS } from 'constants/general'
import { BUTTON_VARIANT } from 'utils/constants'
import Button from 'components/Common/Button'
import Icon from 'icons/Icon'

const ForgotPasswordForm = ({ setAuthTab }) => {
  const {
    loading,
    handleForgotPassword,
    isEmailSent,
    email,
    languageData
  } = useForgotPassword()

  return (
    <>
      {loading
        ? <Loader top='40vh' />
        : (
          <section className='login-signup-modal'>
            {isEmailSent
              ? (
                <div className='fp-mail-send-success'>
                  <Icon name='mail-send-success' className='mail-send-success-icon' />
                  <h2 className='form-heading'>{languageData?.checkYourEmail || 'Check your email'}</h2>
                  <p className='form-text'>{languageData?.passResetLink || 'We’ve sent a password reset link to'}:</p>
                  <p className='form-text email-text color'>{email}</p>
                </div>
                )
              : (
                <div className='forget-password-container'>
                  <p className='forget-password-title'>
                    {languageData?.toContinueResettingYourPassword || 'To continue resetting your password'}
                  </p>
                  <p className='forget-password-description'>
                    {languageData?.toContinueResettingYourPasswordDescription || 'Please enter your email address below and we will send you a link to reset your password.'}
                  </p>
                  <Formik
                    initialValues={{ email: '' }}
                    validationSchema={forgetPasswordSchema(languageData)}
                    onSubmit={({ email }) => handleForgotPassword({ email })}
                  >
                    {(formik) => (
                      <Form className='auth-form-modal'>
                        <FormFieldControl
                          type='email'
                          name='email'
                          control='input'
                          placeholder={languageData?.emailPlaceholder}
                          containerClassName='custom-form-group'
                          fieldClassName='form-control custom-input'
                          showLabel={false}
                        />
                        <UserRegisterButton
                          formik={formik}
                          loading={loading}
                          spinner
                          text={languageData?.resetPassword}
                          className='btn-hover-effect reset-password-btn'
                        />
                      </Form>
                    )}
                  </Formik>
                </div>
                )}
            <Button
              variant={BUTTON_VARIANT.PRIMARY}
              type='button'
              className='btn-hover-effect back-to-login-btn'
              onClick={() => setAuthTab(AUTH_MODAL_TABS.LOGIN)}
            >
              {languageData?.backToLogin || 'Back to Login'}
            </Button>
          </section>)}
    </>
  )
}

export default ForgotPasswordForm
